// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/callback","layout":false,"id":"1"},"2":{"path":"/user","layout":false,"id":"2"},"3":{"name":"login","path":"/user/login","parentId":"2","id":"3"},"4":{"path":"/map","layout":false,"id":"4"},"5":{"path":"/easy-record","name":"记录易","icon":"folder","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/","redirect":"/easy-record","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"*","layout":false,"id":"7"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__callback" */'@/pages/callback.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__map" */'@/pages/map.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "modules__easy-record__pages__V3Workspace" */'@/modules/easy-record/pages/V3Workspace.tsx')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/app/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
